<template>
  <div>
    <sui-text-field
      v-model="textValue"
      placeholder="Input text"
      default
    />
    <sui-text-field
      placeholder="Input text"
      default
      value="This textfield is readonly."
      readonly
    />
    <sui-text-field
      placeholder="Input text"
      default
      value="This textfield is readonly."
      disabled
    />
    <hr>
    <div>Value : {{ textValue }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      textValue: '',
    };
  },
};
</script>
